<!-- 고객센터 페이지 탭/목록 노출 담당 컴포넌트 -->
<script>
  import HeaderTab from '@/components/customer/HeaderTab'

  export default {
    name: 'CustomerSupportContainer',
    components: {
      HeaderTab,
    },
  }
</script>

<template>
  <div class="wrap">
    <div class="cs-body">
      <HeaderTab />
      <RouterView :key="`customer_${$route.name}`" name="customerContent" />
    </div>
  </div>
</template>
